/* eslint-disable @typescript-eslint/no-explicit-any */
/**
 * @desc 旗舰店内部演出搜索.分类,精彩演出查询
 */
import { defaultSuccess, defaultError, http } from "@/plugins/axios";

export default async function (
  condition: good.ShopCategoryCondition,

  success: ({
    data,
    ext,
    state,
    errors,
  }: {
    data: good.Page<good.RecommendProductDto>;
    ext: ObjectMap;
    state: "SUCCESS" | "FAIL" | "EXCEPTION";
    errors?: Array<string>;
  }) => void = defaultSuccess,
  fail: (error: string) => void = defaultError
): Promise<void> {
  return http({
    method: "post",
    url: `/good/shop/products`,
    data: condition,
  })
    .then((data) => success(data as any))
    .catch((error) => fail(error));
}
